import styled from 'styled-components'

export const StyledAcceptJATOTermAndCondition = styled.div``
